export function BrandContainer() {
  return (
    <div className="bg-white w-full h-[50px] rounded-[5px] flex items-center justify-center mt-[12px] desktop-xmd:mt-0 desktop-xmd:h-[125px]">
      <span className="flex items-center rounded-[50px] h-[33px] border border-[#C5C7FF] p-[12px] text-[12px]">ブランドオプション</span>
    </div>
  )
}